export enum CalendarItemStatus {
  NEW_DATE = 'NEW DATE',

  POSTPONED = 'POSTPONED',

  CANCELED = 'CANCELED',
}
